import React from 'react';
import {
  CardMedia,
  Card,
  Button,
  CardActions,
  CardTitle
} from '@one-thd/sui-atomic-components';
import classNames from 'classnames';
import ListsHeader from '../ListsHeader';
import { nullStatePropTypes } from './nullStatePropTypes';
import { defaultCardContentProps } from '../../../constants/responsiveClassNames';
import CreateNewList from '../CreateNewList';
import { NAVIGATION_URLS } from '../../../constants/navigationUrls';

const DesktopNullView = ({
  cardTitle,
  cardBody,
  imageUrl,
  imageAlt,
}) => {

  return (
    <Card
      data-component="Lists"
      data-testid="lists"
      orientation="horizontal"
      className="sui-h-full"
      CardContentProps={{
        className: classNames(
          defaultCardContentProps,
          'sui-h-full',
          'sui-w-full'
        )
      }}
    >
      {/* eslint-disable-next-line react/no-unknown-property */}
      <div className="sui-flex sui-gap-4 sui-h-full">
        <div className=" sui-flex sui-flex-col sui-gap-4 sui-h-full sui-min-w-max">
          <div className="sui-mb-4">
            <ListsHeader />
          </div>
          <CardTitle
            headerVariant="h3"
            headerWeight="display"
            header={cardTitle}
          />
          {cardBody}
          <CardActions>
            <div className="sui-flex sui-gap-4 sui-text-nowrap">
              <Button fullWidth variant="secondary" href={NAVIGATION_URLS.LEARN_MORE}>Learn More</Button>
              <CreateNewList variant="button" />
            </div>
          </CardActions>
        </div>
        <div>
          <CardMedia
            src={imageUrl}
            alt={imageAlt}
            className={`sui-w-full sui-h-full sui-transform
                 sui-object-cover sui-object-center`}
          />
        </div>
      </div>
    </Card>
  );
};

DesktopNullView.propTypes = nullStatePropTypes;

export default DesktopNullView;
